import { Link } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";

import styled from "styled-components";
import ContainedButton from "../../components/Buttons/ContainedButton";

const ReturnsForm = ({
  fontColor: _fontColor,
  background = "white",
  title = "Need Help?",
  headerStyles = {},
}) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const { t } = useTranslation();
  const theme = useTheme();

  const fontColor = _fontColor || theme.COLORS.BLUE.darkBlueGreen;
  return (
    <FormContainer background={background}>
      <Body>
        <Header fontColor={fontColor} style={{ ...headerStyles }}>
          {t(title)}
        </Header>
          <Header fontColor={fontColor} style={{ ...headerStyles }}>
          {t("Send Us A Message!")}
        </Header>
        <ComboContainer>
          <Label fontColor={fontColor}>{t("Full Name")}</Label>
          <Input value={fullName} onChange={e => setFullName(e.target.value)} />
        </ComboContainer>
        <ComboContainer>
          <div className="row">
            <div className="col-6">
              <Label fontColor={fontColor}>{t("Email Address")}</Label>
              <Input value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <div className="col-6">
              <Label fontColor={fontColor}>{t("Phone Number")}</Label>
              <Input
                value={phoneNumber}
                onChange={e => setPhoneNumber(e.target.value)}
              />
            </div>
          </div>
        </ComboContainer>
        <ComboContainer>
          <Label fontColor={fontColor}>{t("Subject")}</Label>
          <Input value={subject} onChange={e => setSubject(e.target.value)} />
        </ComboContainer>
        <ComboContainer>
          <Label fontColor={fontColor}>{t("Message")}</Label>
          <TextArea
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
        </ComboContainer>
        <Link
          to={""}
          style={{
            color: theme.COLORS.WHITE.backgroundWhite,
            textDecoration: "none",
            width: "auto",
          }}
        >
          <ContainedButton
            className="col-auto d-flex justify-content-end"
            styles={{ width: "140px", marginTop: "10px" }}
          >
            {t("SUBMIT")}
          </ContainedButton>
        </Link>
      </Body>
      <div
        style={{
          borderRadius: "0px 50px 0px 50px",
          width: 50,
          height: 140,
          borderWidth: "3px",
          borderStyle: "solid",
          borderColor: theme.COLORS.GREEN.green,
          backgroundColor: theme.COLORS.GREEN.green,
          marginLeft: "-30px",
          marginTop: "-100px",
        }}
      />
    </FormContainer>
  );
};

const Input = styled.input`
  background: #f8fbfd;
  border-color: #f8fbfd;
  border-radius: 10px;
  width: 100%;
  height: 45px;
  font-weight: bold;
`;

const TextArea = styled.textarea`
  background: #f8fbfd;
  border-color: #f8fbfd;
  border-radius: 10px;
  width: 100%;
  height: 180px;
  font-weight: bold;
`;

const Label = styled.label`
  color: ${props => props.fontColor};
  margin-bottom: 3px;
  font-weight: bold;
`;

const FormContainer = styled.div`
  width: 808px;
  background: ${props => props.background};
  border-radius: 35px;
  height: 800px;
  margin-top:-20px
`;

const Header = styled.div`
  width: 80%;
  color: ${props => props.fontColor};
  font-size: 2.5rem;
  //height: auto;
  //margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  //margin-bottom: -30px;
  //position: relative;
  text-align: center;
`;

const Body = styled.div`
  height: auto;
  padding-left: 105px;
  padding-right: 105px;
  position: relative;
  margin-top: 30px;
`;

const ComboContainer = styled.div`
  padding-top: 36px;
`;

export default ReturnsForm;
